import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { PositionStatus } from './position-status.interface';
import { PositionStatusService } from './position-status.service';

const service = new PositionStatusService();

export interface PositionStatusState {
   positionStatuses: Array<PositionStatus>;
}

const PositionStatusStore: Module<PositionStatusState, StoreState> = {
   namespaced: true,
   state: {
      positionStatuses: [],
   },
   getters: {
      positionStatuses: (state) => state.positionStatuses,
   },
   mutations: {
      SET_POSITION_STATUSES(state, positionStatuses: Array<PositionStatus>) {
         state.positionStatuses = positionStatuses;
      },
   },
   actions: {
      async getPositionStatuses(context) {
         const response = await service.getPositionStatuses();
         context.commit('SET_POSITION_STATUSES', response.data);
         return response.data;
      },
   },
};

export default PositionStatusStore;
